<script setup lang="ts">
  import { defineEmits, defineProps } from 'vue'

  const props = defineProps({
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  })

  const emit = defineEmits(['click'])
</script>

<template>
  <v-btn
    color="primary"
    variant="text"
    :disabled="props.disabled || props.loading"
    :loading="props.loading"
    @click="emit('click')"
  >
    <slot></slot>
  </v-btn>
</template>

<style scoped></style>
